/**
 * @generated SignedSource<<5067d9db6881695873df4459f0112cff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SurveyStatus = "AVAILABLE" | "FAIL" | "PENDING" | "SUCCESS";
import { FragmentRefs } from "relay-runtime";
export type useSurveyCardFragmentQuery_surveyRef$data = {
  readonly adminData: {
    readonly rankScore: number;
    readonly surveyGuid: string;
  } | null;
  readonly baseReward: {
    readonly cents: number;
    readonly currency: string;
    readonly formatted: string;
  } | null;
  readonly durationDetails: {
    readonly providerDuration: number;
  };
  readonly iconUrl: string;
  readonly id: string;
  readonly lockedInfo: {
    readonly title: string | null;
  } | null;
  readonly rewardAmount: {
    readonly currency: string;
    readonly formatted: string;
    readonly subUnitAmount: number;
  } | null;
  readonly status: SurveyStatus;
  readonly studyId: string | null;
  readonly supportId: string | null;
  readonly tags: ReadonlyArray<string>;
  readonly title: string;
  readonly url: string | null;
  readonly " $fragmentType": "useSurveyCardFragmentQuery_surveyRef";
};
export type useSurveyCardFragmentQuery_surveyRef$key = {
  readonly " $data"?: useSurveyCardFragmentQuery_surveyRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSurveyCardFragmentQuery_surveyRef">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formatted",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSurveyCardFragmentQuery_surveyRef",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iconUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrencyAmount",
      "kind": "LinkedField",
      "name": "rewardAmount",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subUnitAmount",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MoneyAmount",
      "kind": "LinkedField",
      "name": "baseReward",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cents",
          "storageKey": null
        },
        (v1/*: any*/),
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LockedSurveyInfo",
      "kind": "LinkedField",
      "name": "lockedInfo",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DurationDetails",
      "kind": "LinkedField",
      "name": "durationDetails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "providerDuration",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tags",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "studyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminSurveyData",
      "kind": "LinkedField",
      "name": "adminData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rankScore",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "surveyGuid",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Survey",
  "abstractKey": null
};
})();

(node as any).hash = "c09c2e74a2a7651e3468cee404595b9b";

export default node;
